import { IMarketplace } from "../interfaces/IMarketplace";

/**
 * As rotas do front-end-marketplace ficam sob `/[slug]`. Com domínio customizado a
 * `urlExterna` costuma ser só a raiz, então o slug entra no caminho quando faltar
 * (mesma regra do `urlBaseCardapio` do ms-marketplaces).
 */
export const urlBaseCardapio = (marketplace?: IMarketplace) => {
    const base = (marketplace?.configuracao?.urlExterna ?? "").replace(/\/+$/, "");
    const slug = marketplace?.configuracao?.slug;

    if (!base || !slug) {
        return base;
    }

    try {
        const segmentos = new URL(base).pathname.split("/").filter(Boolean);
        return segmentos[segmentos.length - 1] === slug ? base : `${base}/${slug}`;
    } catch {
        return base;
    }
};

export const urlMesa = (marketplace: IMarketplace | undefined, token: string) =>
    `${urlBaseCardapio(marketplace)}/mesa/${token}`;
